import { ReactNode } from 'react'
import classNames from 'classnames'

import styles from './app-flex-container.module.scss'

type Props = {
  dataTestId?: string
  children: ReactNode | ReactNode[]
  flexFlow?: 'column' | 'column-reverse' | 'row' | 'row-reverse'
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
  alignItems?: 'center' | 'flex-start' | 'flex-end'
  columnGap?: string
  rowGap?: string
  border?: boolean
  maxWidth?: string
  verticalOnMobile?: boolean
}

const AppFlexContainer = ({
  dataTestId = '',
  children,
  flexFlow = 'row',
  flexWrap = 'wrap',
  justifyContent = 'flex-start',
  alignItems = 'flex-start',
  columnGap = '0px',
  rowGap = '0px',
  border = false,
  maxWidth = 'initial',
  verticalOnMobile = false,
}: Props) => {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        styles.appFlexContainer,
        border && styles.border,
        verticalOnMobile && styles.verticalOnMobile
      )}
      style={{
        flexFlow,
        flexWrap,
        justifyContent,
        alignItems,
        columnGap,
        rowGap,
        maxWidth,
      }}
    >
      {children}
    </div>
  )
}

export default AppFlexContainer
